export default __webpack_public_path__ + "static/media/ico-instagram.2729e2f6.svg";